<dynamic-form
  [label]="label"
  [savingLabel]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Paying' | translate"
  [noSubmit]="deactivateSave"
  [group]="formGroup"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="BeforeSaveCheck()">
  <ng-container class="content">
    <div class="page">
      <div class="totalprice">
        <div class="titletotalprice">
          <span> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Payable" | translate }}: </span>
        </div>
        <div class="price">
          <span>{{ this.order.invoice.PayableTotal | number }}</span>
        </div>
      </div>
      <div *ngFor="let item of receiptPayments; let index = index" class="paymenbox">
        <div class="peyment" *ngIf="item.State !== 3">
          <ssg-select
            [name]="'PaymentMethodId' + item.Index"
            class="peymenttype"
            [group]="formGroup"
            [dataList]="item.PaymentMethod"
            (valueChange)="calculate(); checkValidation(); checkIsPosPayment($event, item.Index)"
            [disabled]="deactiveForm || item.Id"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PaymentMethodId' | translate"
            textFieldName="Title"
            valueFieldName="Id">
          </ssg-select>
          <ssg-select
            [name]="'ReceiptPaymentTypeId' + item.Index"
            [disabled]="deactiveForm || item.Id"
            textFieldName="Title"
            valueFieldName="Id"
            [dataList]="item.ReceiptPaymentType"
            class="peymentkind"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ReceiptPaymentTypeId' | translate"
            (valueChange)="checkIsPosPayment($event, item.Index); calculate()">
          </ssg-select>
          <ssg-input
            class="receivedmoney"
            textType="currency"
            hasClear="true"
            [withComma]="true"
            [disabled]="deactiveForm || item.Id"
            [group]="formGroup"
            [name]="'receivedmoney' + item.Index"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Receivedmoney' | translate"
            (valueChange)="calculate()">
          </ssg-input>
        </div>
        <div class="pricebox">
          <div class="deletepeyment" *ngIf="!item.Id && item.ShowPospayment" (click)="Payment(item.Index)">
            <i class="cardicon icon-credit-card1 rotate-right"></i>
          </div>
          <div class="deletepeyment" *ngIf="!item.Id && item.State !== 3" (click)="removePayment(item.Index)">
            <i class="deleteicon icon-delete-o"></i>
          </div>
        </div>
      </div>
      <div class="addpeyment" (click)="addPayment()"><i class="icon icon-add-o"></i></div>

      <div class="debtor" *ngIf="hasDebitTransfer">
        <ssg-input
          [group]="formGroup"
          hasClear="true"
          (clear)="clear(PaymentEnum.Debit)"
          [required]="false"
          name="debit"
          textType="currency"
          [withComma]="true"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Debit' | translate"
          size="select-sm"
          (click)="changeInputValue(PaymentEnum.Debit, null)"
          (valueChange)="changeInputValue(PaymentEnum.Debit, $event)">
        </ssg-input>
        <div class="transfertodebt" (click)="transfer(PaymentEnum.Debit)">
          <i class="transfericon icon-redo-o"></i>
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.TransferToDebit" | translate }} </span>
        </div>
      </div>
      <div class="credit" *ngIf="hasCreditTransfer">
        <ssg-input
          class="creditinput"
          [group]="formGroup"
          hasClear="true"
          (clear)="clear(PaymentEnum.Credit)"
          [required]="false"
          name="credit"
          textType="currency"
          [withComma]="true"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Credit' | translate"
          size="select-sm"
          (click)="changeInputValue(PaymentEnum.Credit, null)"
          (valueChange)="changeInputValue(PaymentEnum.Credit, $event)">
        </ssg-input>
        <div class="transfertocredit" (click)="transfer(PaymentEnum.Credit)">
          <i class="transfericon icon-redo-o"></i>
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.TransferToCredit" | translate }} </span>
        </div>
      </div>
      <div class="peymentstyle">
        <div class="tip" *ngIf="hasTipTransfer">
          <ssg-input
            hasClear="true"
            (clear)="clear(PaymentEnum.Tip)"
            [group]="formGroup"
            [required]="false"
            name="tip"
            textType="number"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Tip' | translate"
            size="select-sm"
            (click)="changeInputValue(PaymentEnum.Tip, null)"
            (valueChange)="changeInputValue(PaymentEnum.Tip, $event)">
          </ssg-input>
          <div class="transfertocredit" (click)="transfer(PaymentEnum.Tip)">
            <i class="transfericon icon-redo-o"></i>
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.TransferToTip" | translate }} </span>
          </div>
        </div>
        <div class="remaining">
          <ssg-input
            class="remaining"
            [group]="formGroup"
            [required]="false"
            name="remaining"
            textType="currency"
            [withComma]="true"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Remaining' | translate"
            size="select-sm"
            [disabled]="true">
          </ssg-input>
        </div>
      </div>
      <div class="price" *ngIf="isDeposit && order.saleMethodBranch.SaleMethodNatureCode === order.SaleMethodNature.Delivery">
        <ssg-checkbox
          id="NonBalance"
          name="NonBalance"
          [group]="formGroup"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.NonBalance' | translate"
          (valueChange)="nonBalanceValidation()">
        </ssg-checkbox>
      </div>
    </div>
  </ng-container>
</dynamic-form>
